import { dayKey } from "@/lib/streak";

const WEEKDAYS = ["S", "M", "T", "W", "T", "F", "S"];

// Last 4 full weeks (Sun–Sat), ending with the current week.
function buildWeeks(now = new Date()) {
  const start = new Date(now);
  start.setDate(now.getDate() - now.getDay() - 21);
  return Array.from({ length: 28 }, (_, i) => {
    const d = new Date(start);
    d.setDate(start.getDate() + i);
    return d;
  });
}

export const StreakCalendar = ({ days = [] }) => {
  const visited = new Set(days);
  const now = new Date();
  const today = dayKey(now);
  const cells = buildWeeks(now);
  const monthTotal = days.filter((d) => d.startsWith(today.slice(0, 7))).length;

  return (
    <div className="mt-5 pt-5 border-t border-white/5" data-testid="streak-calendar">
      <div className="flex items-baseline justify-between mb-3">
        <p className="font-mono-rts text-[0.62rem] tracking-[0.3em] uppercase text-white/50">Your road · 4 weeks</p>
        <p className="font-mono-rts text-[0.62rem] text-white/40" data-testid="streak-calendar-month-total">
          {monthTotal} day{monthTotal === 1 ? "" : "s"} this month
        </p>
      </div>
      <div className="grid grid-cols-7 gap-1.5">
        {WEEKDAYS.map((w, i) => (
          <span key={`w${i}`} className="text-center font-mono-rts text-[0.55rem] text-white/30">{w}</span>
        ))}
        {cells.map((d) => {
          const key = dayKey(d);
          const on = visited.has(key);
          const isToday = key === today;
          const future = d > now && !isToday;
          return (
            <span
              key={key}
              title={d.toDateString()}
              data-testid={`streak-day-${key}`}
              data-visited={on ? "true" : "false"}
              className={[
                "aspect-square rounded-md flex items-center justify-center text-[0.6rem] font-mono-rts transition-colors duration-300",
                on ? "bg-[#EAB308]/85 text-[#0F111A] shadow-[0_0_10px_rgba(234,179,8,0.35)]" : "bg-white/[0.04] text-white/30",
                isToday ? "ring-1 ring-[#EAB308] ring-offset-1 ring-offset-[#0F111A]" : "",
                future ? "opacity-30" : "",
              ].join(" ")}
            >
              {d.getDate()}
            </span>
          );
        })}
      </div>
    </div>
  );
};
